import { render } from "./Connection2.vue?vue&type=template&id=b668bfea"
import script from "./Connection2.vue?vue&type=script&lang=js"
export * from "./Connection2.vue?vue&type=script&lang=js"

import "./Connection2.vue?vue&type=style&index=0&id=b668bfea&lang=css"

import exportComponent from "/Users/smzdm/Desktop/前端项目/畅效官网/cx_official_website/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__